import "./Video.module.css";
import Header from "@/reusable_sections/Header";
import PopularMovies from "./sections/PopularMovies";
import Footer from "@/reusable_sections/Footer";
export default function VideoPage() {
  return <div>
      <Header />
      <PopularMovies />
      <Footer />
    </div>;
}